// extracted by mini-css-extract-plugin
export default {"root":"pS5Yxk4iy_lbpQiKGlUT","body":"qNnD1Ww0pMvlnGCvRFB8"};